<app-deprecated-confirmation-dialog
    #deletePolicyModal
    header="{{ 'time-off-v3.deleteTimeOffPolicy' | translate }}"
    label="{{ 'time-off-v3.delete' | translate }}"
    useNgContent="true"
    [negative]="true"
>
    <p>{{ 'time-off-v3.areYouSureYouWantToDeleteThisTimeOffPolicy' | translate }}</p>
    <p>{{ 'time-off-v3.thisWillImmediatelyUnassignAllEmployeesFromThisPolicyEffectiveImmediately' | translate }}</p>
    <p>{{ 'time-off-v3.ifYouPutTheEmployeesBackOntoA' | translate }}</p>
</app-deprecated-confirmation-dialog>

<app-deprecated-confirmation-dialog
    #deleteTypeModal
    header="Delete Time Off Type"
    label="{{ 'time-off-v3.delete' | translate }}"
    [negative]="true"
    [useNgContent]="true"
>
    <b>{{ 'time-off-v3.areYouSureYouWantToDeleteThisTimeOffType' | translate }}</b>
    <p>{{ 'time-off-v3.thisWillIrreversiblyDeleteAllRequestsPolicies' | translate }}</p>
</app-deprecated-confirmation-dialog>

<app-deprecated-modal-form
    [stubby]="true"
    headerText="{{ 'time-off-v3.reassignEmployees' | translate }}"
    [form]="policyReassignForm"
    #policyReassignDialog
    (save)="onReassignPolicy()"
>
    <app-reassign-policy-form #policyReassignForm></app-reassign-policy-form>
</app-deprecated-modal-form>

<div class="page-container" [class.loading]="isLoading">
    <app-header
        title="{{ hasTimeOffImprovement ? 'time-off-v3.timeOffPolicies' : 'time-off-v3.typesPolicies' }}"
        [menuService]="timeOffModuleMenuService"
    >
        <ui-button *ngIf="!hasTimeOffImprovement" class="buttons" type="primary" [routerLink]="['types', 'create']"
            >{{ 'time-off-v3.createTimeOffType' | translate }}
        </ui-button>
        <ui-button
            *ngIf="hasTimeOffImprovement"
            class="buttons"
            type="primary"
            [routerLink]="['/time-off', 'v3', 'policy', 'create']"
            ><mat-icon svgIcon="plus"></mat-icon>{{ 'time-off-v3.createTimeOffPolicy' | translate }}
        </ui-button>
    </app-header>

    <app-empty-state
        *ngIf="timeOffTypes.length === 0"
        label="time-off-v3.noTimeOffTypesFound"
        src="/assets/illustrations/calendar.png"
    ></app-empty-state>

    <div *ngFor="let table of typeAndPolicyTables">
        <app-locked-type
            *ngIf="table.timeOffType.isLocked"
            [timeOffType]="table.timeOffType"
            [payload]="getEventPayload(table.timeOffType.id)"
        ></app-locked-type>
        <app-table
            *ngIf="!table.timeOffType.isLocked"
            [useStickyHeader]="false"
            [showSearch]="false"
            [table]="table"
            [showPagination]="false"
            [title]="table.timeOffTypeName"
            subTitle="{{ hasTimeOffImprovement ? ('time-off-v3.types-and-policies-table.subTitle' | translate) : '' }}"
            (menuItemSelected)="menuAction($event, table)"
            [options]="getTimeOffTypeTableOptions(table.timeOffType)"
        >
            <app-empty-state
                label="time-off-v3.noPoliciesAddedYet"
                src="/assets/illustrations/empty-box.png"
            ></app-empty-state>
            <div class="buttons">
                <ui-button
                    *ngIf="!hasTimeOffImprovement"
                    class="buttons"
                    type="outline"
                    (click)="createNewPolicy(table.timeOffType.id)"
                >
                    <mat-icon svgIcon="plus"></mat-icon>{{ 'time-off-v3.createPolicy' | translate }}
                </ui-button>
                <button [matMenuTriggerFor]="meatball" class="meatballs">
                    <mat-icon svgIcon="meatballHorizontal"></mat-icon>
                </button>
                <mat-menu #meatball xPosition="before">
                    <button mat-menu-item [routerLink]="['types', table.timeOffType.id, 'edit']">
                        {{ 'time-off-v3.editType' | translate }}
                    </button>
                    <button mat-menu-item (click)="onDeleteTimeOffType(table.timeOffType)">
                        {{ 'time-off-v3.deleteType' | translate }}
                    </button>
                    <button
                        mat-menu-item
                        (click)="onMarkAsDefaultTimeOffType(table.timeOffType)"
                        *ngIf="!table.timeOffType.isDefault"
                    >
                        {{ 'time-off-v3.markAsDefault' | translate }}
                    </button>
                </mat-menu>
            </div>
        </app-table>
    </div>
</div>
